<template>
  <div>
    <div class="g-flex g-items-center g-w-full g-bg-white g-overflow-hidden g-border g-border-grey-200" :class="{ 'g-rounded-t': rounded }">
      <div class="g-font-bold g-px-4 g-py-2">{{ title }}</div>
    </div>

    <div class="g-w-full g-rounded-b g-px-4 g-py-4 g-bg-white g-border g-border-t-0 g-border-grey-200">
      <slot name="top"></slot>

      <ul class="">
        <li
          v-for="option of options"
          :key="option.id"
          class="g-flex g-pb-4 g-pt-4 g-border-t-4 g-border-grey-150"
          :class="{ 'g-opacity-50': !($store.state.zusammenstellung.basket[option.id] > 0) && highlightChoices }"
          v-show="$store.state.zusammenstellung.basket[option.id] > 0 || !highlightChoices || isExpanded || nonSelected"
        >
          <div class="g-mr-4">
            <img class="g-w-24" :src="getImageUrl(option)" />
          </div>

          <div>
            <p v-if="meterware" class="g-text-xl g-font-bold">
              {{ Number(getAttributeValue(option, attributeName)) | formatPrice }}<span class="g-pl-1 g-font-normal g-text-sm">m</span>
            </p>
            <p v-else class="g-text-xl g-font-bold">
              <span v-if="option.unit">{{ option.unit.content }}</span
              ><span class="g-pl-1 g-font-normal g-text-sm">liter</span>
            </p>

            <p class="g-text-sm">{{ option.texts[0].name1 }}</p>
            <p v-if="meterware" class="g-text-lg">
              {{ (getPrice(option) * getAttributeValue(option, attributeName)) | formatPrice }} EUR
              <span class="g-text-grey-500 g-text-sm">pro Meter</span>
            </p>
            <p v-else class="g-text-lg">{{ getPrice(option) | formatPrice }} EUR</p>
          </div>

          <div class="g-flex g-self-stretch g-items-center g-ml-auto">
            <div v-if="meterware === true" class="">
              <p class="g-mr-2">Meter</p>
            </div>

            <quantity-input
              :allowDecimal="meterware === true"
              @change="updateQuantity(option, $event)"
              :quantity="$store.state.zusammenstellung.basket[option.id] || 0"
              :stepSize="(meterware === true) ? 0.01 : 1"
            ></quantity-input>
          </div>
        </li>
      </ul>

      <div class="g-flex g-items-center g-py-4 g-px-1 g-border-t g-border-grey-200 g-cursor-pointer" @click="isExpanded = !isExpanded" v-if="highlightChoices && !nonSelected">
        <gp-icon
          :icon="['fas', 'arrow-down']"
          class="g-text-white g-bg-green-500 g-opacity-50 g-rounded-sm g-p-[2px]"
          :style="{
            transform: (isExpanded) ? 'scale(1.7, 1.6) rotate(180deg)' : 'scale(1.7, 1.6)'
          }"
        />
        <p class="g-ml-4 g-text-grey-900">
          <span v-if="!isExpanded">Weitere</span><span v-if="isExpanded">Weniger</span> Optionen Anzeigen
        </p>
      </div>

      <slot name="bottom"></slot>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import QuantityInput from "./QuantityInput.vue";
import { getAttributeValue, getPrice } from "../plentyHelpers.js";
import ENV from "../environment";

export default {
  components: { QuantityInput },
  name: "ProductQuantityList",

  props: ["options", "title", "module", "rounded", "attributeName", "meterware", "highlightChoices"],

  data() {
    return {
      images: {},
      isExpanded: false,
    };
  },

  computed: {
    nonSelected() {
      let productsSelected = 0;
      
      this.options.forEach(option => {
        if (this.$store.state.zusammenstellung.basket[option.id]) productsSelected += 1;
      })

      return productsSelected < 1;
    },
  },

  methods: {
    getAttributeValue,
    getPrice,

    updateQuantity(option, quantity) {
      this.$store.commit("zusammenstellung/setBasketItem", {
        variationId: option.id,
        quantity: quantity,
      });
    },

    getImageUrl(option) {
      return this.images[option.id]?.urlMiddle;
    },

    async fetchImages(options = this.options) {
      let images = {};

      // Fetch image for each option and store it in the images object
      await Promise.all(
        options.map(async (option) => {
          let image = await axios.get(ENV.imageEndpoint + `?itemId=${option.itemId}&pluginSetPreview=${ENV.setPreview}`);
          images[option.id] = image.data.images[0];
        })
      );

      this.images = images;
    },

    changeQuantity(option, event) {
      this.$emit("changeQuantity");
    },
  },

  watch: {
    options(newOptions, oldOptions) {
      // Fetch images when options are initially passed to the component
      if (newOptions.length && !oldOptions.length) {
        return this.fetchImages();
      }

      let imagesMissing = newOptions.some((option) => !this.images[option.id]);

      if (imagesMissing) {
        this.fetchImages(newOptions.filter((option) => !this.images[option.id]));
      }
    },
  },
};
</script>

<style></style>
